import 'antd/dist/antd.css'
import { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    @media screen and (min-width: 1400px){
      a {
        font-size: 18px;
      }
      h2 {
        font-size: 2.4em;
        margin-bottom: 10px;
      }
      h4, h3 {
        font-size: 20px;
        margin-bottom: 10px;
      }
      p {
        font-size: 18px;
      }
    }
  }

  .container {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    @media screen and (min-width: 540px){
      max-width: 540px;
    }
    @media screen and (min-width: 768px){
      max-width: 720px;
    }
    @media screen and (min-width: 992px){
      max-width: 960px;
    }
    @media screen and (min-width: 1200px){
      max-width: 1140px;
    }
    @media screen and (min-width: 1400px){
      max-width: 1320px;
    }
  }

  ${normalize}
  .d-none {
    display: none !important;
  }
  @media (min-width: 992px) {
    .d-lg-block {
      display: block !important;
    }
    
    .d-lg-none {
      display: none !important;
    }
  }
`
export default GlobalStyle
